/* Indus Organics – premium theme behaviours */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Banner slider */
  function initSlider(root) {
    if (root.dataset.ioReady) return;
    root.dataset.ioReady = '1';
    var track = root.querySelector('[data-io-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-io-dot]'));
    var index = 0;
    var timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;

    function go(i, smooth) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      mark();
    }
    function mark() {
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }
    function play() {
      stop();
      if (delay > 0 && !reduceMotion && slides.length > 1) {
        timer = setInterval(function () { go(index + 1); }, delay);
      }
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = root.querySelector('[data-io-prev]');
    var next = root.querySelector('[data-io-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.ioDot, 10)); play(); });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index) { index = i; mark(); }
      }, 80);
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    mark();
    play();
  }

  /* Tabs */
  function initTabs(root) {
    if (root.dataset.ioReady) return;
    root.dataset.ioReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      window.dispatchEvent(new Event('resize'));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });
  }

  /* Delivery estimate */
  function initDelivery(root) {
    var out = root.querySelector('[data-io-delivery-range]');
    if (!out) return;
    var min = parseInt(root.dataset.min || '4', 10);
    var max = parseInt(root.dataset.max || '7', 10);
    var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
    function add(n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-IN', fmt); }
    out.textContent = 'between ' + add(min) + ' and ' + add(max);
  }

  /* Sticky add to cart */
  function initSticky(bar) {
    if (bar.dataset.ioReady) return;
    bar.dataset.ioReady = '1';
    var anchor = document.querySelector('.product-form__buttons') || document.querySelector('product-info');
    if (!anchor || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('io-sticky-on', past);
    });
    io.observe(anchor);
    var btn = bar.querySelector('[data-io-sticky-add]');
    if (btn) btn.addEventListener('click', function () {
      var main = document.querySelector('product-info .product-form__submit, .product-form__buttons .product-form__submit');
      if (main && !main.disabled) { main.click(); }
      else if (anchor) { anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); }
    });
  }

  /* Product carousel arrows */
  function initCarousel(root) {
    if (root.dataset.ioCarReady) return;
    root.dataset.ioCarReady = '1';
    var track = root.querySelector('[data-io-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-io-carousel-prev]');
    var next = root.querySelector('[data-io-carousel-next]');
    function step() {
      var item = track.querySelector('li');
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('io-carousel--static', max <= 0);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Read more */
  function initReadMore(root) {
    if (root.dataset.ioRmReady) return;
    root.dataset.ioRmReady = '1';
    var body = root.querySelector('[data-io-readmore-body]');
    var btn = root.querySelector('[data-io-readmore-toggle]');
    if (!body || !btn) return;
    var limit = parseInt(getComputedStyle(body).getPropertyValue('--io-collapsed'), 10) || 240;
    if (body.scrollHeight <= limit + 40) return;
    root.classList.add('is-collapsible');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-more]').hidden = open;
      btn.querySelector('[data-less]').hidden = !open;
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-io-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-io-readmore]').forEach(initReadMore);
    scope.querySelectorAll('[data-io-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-io-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-io-delivery]').forEach(initDelivery);
    scope.querySelectorAll('[data-io-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
